var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.9829 3.33325H13.0329C6.96627 3.33325 3.34961 6.94991 3.34961 13.0166V26.9666C3.34961 33.0332 6.96627 36.6499 13.0329 36.6499H26.9829C33.0496 36.6499 36.6663 33.0332 36.6663 26.9666V13.0166C36.6663 6.94991 33.0496 3.33325 26.9829 3.33325Z",
    fill: "#04EEAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8508 18.5835H12.4342C11.3842 18.5835 10.5342 19.4334 10.5342 20.4834V29.0167H16.8508V18.5835V18.5835Z",
    fill: "#1F2937"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.2673 11.0002H18.734C17.684 11.0002 16.834 11.8503 16.834 12.9003V29.0003H23.1507V12.9003C23.1507 11.8503 22.3173 11.0002 21.2673 11.0002Z",
    fill: "#1F2937"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5836 21.4167H23.167V29.0002H29.4837V23.3168C29.467 22.2668 28.617 21.4167 27.5836 21.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartSquare);
export default __webpack_public_path__ + "static/media/chart-square.28f08f9975be8990876d8fcf723edffa.svg";
export { ForwardRef as ReactComponent };